module.exports = ":host {\n  display: block; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/containers/season-container/season-container.style.scss
// module id = 875
// module chunks = 2